import { useQuery } from 'react-query';

import { useAuth0 } from '@auth0/auth0-react';
import setToken from '../../utils/api';
import { UserItem } from '../../types/IUserResponse';

export interface MenuData {
  pages: any[];
  user: UserItem | null;
}

export default function useMenuItems() {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery<MenuData, Error>(
    ['menu-items'],
    async () => {
      const token = await getAccessTokenSilently();
      const api = await setToken(token);
      const response = await api.get<MenuData>(`api/menu`, {});

      if (response?.status !== 200) {
        throw new Error(`Couldn't find menu`);
      }

      return response.data;
    },
    {
      keepPreviousData: true,
    },
  );
}
